import CardsavrRestError from "@strivve/strivve-sdk/lib/cardsavr/CardsavrRestError";
import CardsavrSDKError from "@strivve/strivve-sdk/lib/cardsavr/CardsavrSDKError";
import { useRouter } from 'next/router';

export function handleErrorPage(err) {

    let message;
            
    if(err.statusCode > 399 && err.statusCode < 500 && err.response && err.response.body && err.response.body._errors){
        message = '';
        err.response.body._errors.map((error, index)=>{
            message = message + error.message;
            if(index < err.response.body._errors.length - 1){
                message = message + "; ";
            }
        })
        return message;
    }
    else{
        return false;
    }
}

export function handleErrorConsole(err) {

    const router = useRouter();

    if (err instanceof CardsavrRestError || (err.type && err.type === "CardsavrRestError")) {
        if (err.errors) {
            console.log("Errors returned from REST API : " + err.response.call);
            err = err.response;
            err.body._errors.map((obj) => {
                console.log(obj);
            });
        } else if (err.response.body) {
            console.log(err.response);
            console.log("Message returned from REST API: " + err.response.body.message);
        }
    } else if (err instanceof CardsavrSDKError || (err.type && err.type === "CardsavrSDKError")) {
        console.log("SDK errors, exception stack below:");
        console.log(err.errors);
        console.log(err.stack);
    } else {
        console.log("no errors from REST API, full error below:");
        console.log(err);
    }

    if(err.statusCode === 401){
        router.push("/login");
    }
    else if(err.statusCode === 403 && err.response.body._errors[0].name === "Password Update Required") {
            router.push('/reset_password');
    }
}

export async function refresh_user_session(username, CardupdatrHelper) {
    const ch = CardupdatrHelper.getInstance();
    const session = ch.getSession(username);
    await session.refresh();
}

// vanillaJS
export function isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}

export function trim_object_values(obj) {
    if ( obj ){
        // make a copy
        const obj_copy = JSON.parse(JSON.stringify(obj));
        Object.keys(obj_copy).forEach(key => {
            obj_copy[key] = obj_copy[key]?.trim();
        })

        return obj_copy;
    }
    return obj;
}

export function get_hash_key_values() {
    const hash = window.location.hash ? window.location.hash.substring(1) : "";
    const ret = {};
    hash.split("&").filter(item => item).map(item => {
        let [key, val] = item.split("=");
        val = decodeURIComponent(val);
        if (ret[key]) { // merge dupes into an array -- if val is a single object, val becomes an array with the new val
            val = ret[Array.isArray(key)] ? [...ret[key], val] : [ret[key], val];
        }
        ret[key] = val;
    });
    return ret;
}

export function merge_hash_key_values(obj) {
    return Object.keys(obj).map((key) => obj[key] ? `${key}=${encodeURIComponent(obj[key])}` : "").join("&");
}

export async function get_merchant_sites(CardupdatrHelper, username, top_sites, merchant_sites_tag_array) {
    const ch = CardupdatrHelper.getInstance();
    const session = ch.getSession(username);
    const filters = { tags : merchant_sites_tag_array, image_widths : "128,32" };
    filters.top_hosts = top_sites ? top_sites.toString() : null;
    // TODO: Need to add pagination support. SiteTileContainer will need relatively large refactoring to support this.
    const sites_response = await session.getSites(filters, { page : 1, page_length : 9999, sort : "name", is_descending : false });
    const merchant_sites = sites_response.body;
    return merchant_sites;
}

export async function get_fi(CardupdatrHelper, username, lookup_key) {
    const ch = CardupdatrHelper.getInstance();
    const session = ch.getSession(username);
    const filters = { lookup_key };
    const fis_response = await session.getFinancialInstitutions(filters);
    const fi = fis_response.body;
    return fi;
}

export async function update_user_jobs(CardupdatrHelper, username, cardholder_id, card_id) {
    const ch = CardupdatrHelper.getInstance();
    const cardholder_session = ch.getSession(username);
    return await cardholder_session.updateSingleSiteJobs({ cardholder_ids : cardholder_id }, { card_id });
}

module.exports = { handleErrorConsole, handleErrorPage, get_hash_key_values, merge_hash_key_values, get_merchant_sites, refresh_user_session, update_user_jobs, isJSON, trim_object_values, get_fi };
